import { useEffect, useState } from 'react'
import classNames from 'classnames'

import StarIcon from './assets/star.svg'
import ArrowIcon from './assets/arrow.svg'

import styles from './PageBanner.pcss'

function PolRewardBanner(): JSX.Element {
	return (
		<a
			className={classNames(
				styles.container,
				styles.symbiosisStakingContainer
			)}
			href="https://x.com/symbiosis_fi/status/1991435562415452422"
			target="_blank"
			rel="noreferrer"
		>
			<StarIcon />
			<div className={styles.titleContainer}>
				<span className={styles.new}>NEW</span>POL rewards for
				Cross-chain swaps!
			</div>
			<div className={styles.description}>
				Swap into Polygon, Polygon zkEVM, or Katana and get cashback
				weekly <ArrowIcon className={styles.arrowIcon} />
			</div>
			<StarIcon />
		</a>
	)
}

function EthCommissionBanner(): JSX.Element {
	return (
		<a
			className={classNames(
				styles.container,
				styles.symbiosisStakingContainer,
				styles.ethCommissionBanner
			)}
			href="https://x.com/symbiosis_fi/status/1998313212983513322"
			target="_blank"
			rel="noreferrer"
		>
			<StarIcon />
			<div className={styles.titleContainer}>
				<span className={styles.new}>NEW</span>ETH & L2s fees dropped!
			</div>
			<div className={styles.description}>
				0% pool fee, 0% volume fee. Swap for network fee only.{' '}
				<ArrowIcon className={styles.arrowIcon} />
			</div>
			<StarIcon />
		</a>
	)
}

export function PageBanner(): JSX.Element {
	const banners: JSX.Element[] = []

	const [bannerId, setBannerId] = useState<number>(0)

	useEffect(() => {
		const intervalId = setInterval(() => {
			setBannerId((prevState) => {
				let state = prevState + 1
				if (state >= banners.length) {
					state = 0
				}
				return state
			})
		}, 15000)

		return () => {
			clearInterval(intervalId)
		}
	}, [banners.length])

	return banners[bannerId]
}
